import { useEffect } from "react"

interface UseClearModalBackdropElementProps {
    showModal: boolean
}

const useClearModalBackdropElement = ({ showModal }: UseClearModalBackdropElementProps) => {

    useEffect(() => {
        if (!showModal) {
            const getElementBackdrop = document.querySelector('.modal-backdrop') as HTMLDivElement
            if (getElementBackdrop) {
                getElementBackdrop.remove()
            }
        }
    }, [showModal])

}

export default useClearModalBackdropElement